export default __webpack_public_path__ + "img/pin_icons/electronic_white_board_w.png";